import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import React, { Fragment } from "react";
import styled from "styled-components";
import { GhostText } from "@faire/retailer/components/GhostLoading/GhostTypography";
var NUM_FILTER_SECTIONS = 3;
var NUM_SIDENAV_CATEGORIES = 10;
export var FilterSideBarLoadingSkeleton = function(param) {
    var hideSideNav = param.hideSideNav, filterCount = param.filterCount;
    return /*#__PURE__*/ _jsxs(SidebarContainerWithFilters, {
        children: [
            hideSideNav ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(GhostText, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        style: {
                            paddingLeft: getSpacing("2x")
                        },
                        children: Array.from({
                            length: NUM_SIDENAV_CATEGORIES
                        }).map(function(_, index) {
                            return /*#__PURE__*/ _jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(FilterPlaceholder, {}),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: "2x"
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx(HorizontalLine, {})
                ]
            }),
            Array.from({
                length: filterCount !== null && filterCount !== void 0 ? filterCount : NUM_FILTER_SECTIONS
            }).map(function(_, index) {
                return /*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "3x"
                        }),
                        /*#__PURE__*/ _jsx(GhostText, {}),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "3x"
                        }),
                        /*#__PURE__*/ _jsx(HorizontalLine, {})
                    ]
                }, index);
            })
        ]
    });
};
var SidebarContainerWithFilters = styled(Column).withConfig({
    componentId: "sc-8c0a6595-0"
})([
    "flex:0 0 228px;margin-right:",
    ";"
], getSpacing("6x"));
var FilterPlaceholder = styled(GhostText).withConfig({
    componentId: "sc-8c0a6595-1"
})([
    "padding:10px;"
]);
